import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({

  providedIn: 'root'

})

export class ThemeService {

  private currentTheme: string = 'gsp-theme';

  constructor(@Inject(DOCUMENT) private document: Document) { }

  loadTheme(themeName: string): void {

    console.log('Attempting to load theme:', themeName);
    //this.removeExistingThemes();
    const themeLink = this.document.createElement('link');
    themeLink.id = 'app-theme';
    themeLink.rel = 'stylesheet';
    themeLink.type = 'text/css';
    themeLink.href = `${themeName}.css`;
    themeLink.onload = () => {
      this.currentTheme = themeName;
      localStorage.setItem('theme', themeName);

    };
    this.document.head.appendChild(themeLink);
    themeLink.onerror = (error) => {
      this.tryAbsolutePath(themeName);
    };

    this.document.body.setAttribute('data-theme', themeName);
  }

  private removeExistingThemes(): void {

    const existingThemes = this.document.querySelectorAll('link[id="app-theme"]');

    existingThemes.forEach(theme => theme.remove());

  }

  private tryAbsolutePath(themeName: string): void {

    const absolutePath = `${themeName}.css`;

    const themeLink = this.document.createElement('link');

    themeLink.id = 'app-theme';

    themeLink.rel = 'stylesheet';

    themeLink.href = absolutePath;
    this.document.head.appendChild(themeLink);
    themeLink.onload = () => {
      this.currentTheme = themeName;
      localStorage.setItem('theme', themeName);

    };

    themeLink.onerror = (error) => {

      console.error(`❌ Failed to load theme with absolute path:`, error);

    };



  }

  initializeTheme(): void {

    if (this.document.readyState === 'complete') {

      this.loadInitialTheme();

    } else {

      this.document.addEventListener('DOMContentLoaded', () => {

        this.loadInitialTheme();

      });

    }

  }

  private loadInitialTheme(): void {

    const savedTheme = localStorage.getItem('theme') || 'gsp-theme';
    this.loadTheme(savedTheme);

  }

  getCurrentTheme(): string {

    return this.currentTheme;

  }

}
